import Debounce from 'Utils/Debounce';

class StickyContactWidget {
	constructor(element) {
		this.root = element;
		this.items = Array.from(this.root.querySelectorAll('.js-stickyContactWidgetItem'));
		this.onClick = ::this.onClick;
		this.closeAllItems = ::this.closeAllItems;

		this.items.forEach(item => {
			item.addEventListener('click', this.onClick);
		});

		window.addEventListener('scroll', Debounce(this.closeAllItems, 250));
	}

	onClick(e) {
		e.preventDefault();
		if (e.pointerType !== 'touch') {
			this.openOverlay(e.currentTarget.dataset.targetId);
		} else {
			if (e.currentTarget.classList.contains('is-active')) {
				this.openOverlay(e.currentTarget.dataset.targetId);
				this.closeAllItems();
				return;
			}

			this.closeAllItems();

			e.currentTarget.classList.add('is-active');
		}
	}

	openOverlay(id) {
		document.querySelector(`.js-contentOverlay[data-id="${id}"]`).classList.add('is-open');
	}

	closeAllItems() {
		this.items.forEach(item => {
			item.classList.remove('is-active');
		});
	}
}

Array.from(document.querySelectorAll('.js-stickyContactWidget')).forEach(
	el => new StickyContactWidget(el)
);
